import { IEquityMovementSchedule } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class Ems {
    constructor(public equityMovementSchedule: IEquityMovementSchedule) {}

    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
